import React from 'react';
import { TableCell } from '@material-ui/core';
import { Avatar } from 'kangarootime-ui';
import '../../shared/Table.css';

const EmployeeCell = ({ profileImage, name }) => (
  <TableCell className='schedulingRowCell'>
    <div className='flex-rows'>
      <Avatar image={profileImage} size='md' />
      <div className='flex-columns' style={{ marginLeft: 16, justifyContent: 'center' }}>
        <span className='schedulingLabel'>{name}</span>
      </div>
    </div>
  </TableCell>
);

export default EmployeeCell;
